/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import EmailVerifyPost200Response from '../model/EmailVerifyPost200Response';
import EmailVerifyPostRequest from '../model/EmailVerifyPostRequest';

/**
* Email service.
* @module api/EmailApi
* @version 1.0.0
*/
export default class EmailApi {

    /**
    * Constructs a new EmailApi. 
    * @alias module:api/EmailApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Send or verify an email verification code
     * @param {module:model/EmailVerifyPostRequest} emailVerifyPostRequest Either send a code to an email, or verify a code
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/EmailVerifyPost200Response} and HTTP response
     */
    emailVerifyPostWithHttpInfo(emailVerifyPostRequest) {
      let postBody = emailVerifyPostRequest;
      // verify the required parameter 'emailVerifyPostRequest' is set
      if (emailVerifyPostRequest === undefined || emailVerifyPostRequest === null) {
        throw new Error("Missing the required parameter 'emailVerifyPostRequest' when calling emailVerifyPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = EmailVerifyPost200Response;
      return this.apiClient.callApi(
        '/email/verify', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Send or verify an email verification code
     * @param {module:model/EmailVerifyPostRequest} emailVerifyPostRequest Either send a code to an email, or verify a code
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/EmailVerifyPost200Response}
     */
    emailVerifyPost(emailVerifyPostRequest) {
      return this.emailVerifyPostWithHttpInfo(emailVerifyPostRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
